<template>
  <div class="bg-surface rounded-lg p-4 max-w-[58rem] mx-auto mt-6">
    <div v-if="props.resource.fileUrl">
      <img
        v-if="isUrlFirebaseFile(props.resource.fileUrl)"
        :src="props.resource.fileUrl"
        :alt="$t('content.resource-alt')"
        class="w-full object-cover rounded-md aspect-[8/5]"
      />

      <iframe
        v-else-if="isEmbeddedVideoUrl(props.resource.fileUrl)"
        class="w-full aspect-video rounded-md"
        :src="props.resource.fileUrl"
        referrerpolicy="strict-origin-when-cross-origin"
      />

      <Button
        v-else
        label="View Resource"
        :size="ButtonSize.SM"
        :color="ButtonColor.SECONDARY"
        :to="props.resource.fileUrl"
        target="_blank"
      />
    </div>

    <div class="mt-10 prose max-w-full" v-html="props.resource.description" />

    <div v-if="props.resource.displayCtaButton" class="text-center mt-12">
      <Button
        :label="props.resource.ctaButtonText ?? ''"
        :to="props.resource.ctaButtonUrl"
        target="_blank"
        @click="onCtaButtonClick"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button, ButtonColor, ButtonSize } from '@exfluential/ui';
import { isEmbeddedVideoUrl, isUrlFirebaseFile } from '../../content.utils';
import { apiMarkContentCtaButtonClicked, ContentDto } from '~/api/contents';

type Props = {
  hubSlug: string;
  contentSlug: string;
  resource: NonNullable<ContentDto['resource']>;
};
const props = defineProps<Props>();

const onCtaButtonClick = () => {
  apiMarkContentCtaButtonClicked(props.hubSlug, props.contentSlug);
};
</script>
